// sai's product data (brochure-demo src/demo/data/products.js), the parts his
// page frame reads: each product's name, stage, headline and icon. AI Video is
// left out (out of the flow). The order and the "next product" come from our
// STEPS, not from here.

export const STAGES = [
  { key: 'attract', n: 1, label: 'Attract', sub: 'Bring them in' },
  { key: 'deliver', n: 2, label: 'Deliver', sub: 'What they receive' },
  { key: 'counsel', n: 3, label: 'Counsel', sub: "Guide what's next" },
  { key: 'growth', n: 4, label: 'Growth', sub: 'Learn and reach' },
];

// `icon` is resolved to a lucide icon through PRODUCT_ICONS (productIcons.js).
export const PRODUCTS = [
  {
    key: 'smart-report',
    stage: 'deliver',
    name: 'Smart Reports',
    icon: 'FileText',
    line: 'The report you already send, made readable.',
  },
  {
    key: 'viz-app',
    stage: 'deliver',
    name: 'Viz App',
    icon: 'Smartphone',
    line: 'The same report, opened and explored on the phone.',
  },
  {
    key: 'hospital',
    stage: 'deliver',
    name: 'Hospital reports',
    icon: 'Hospital',
    line: 'The prescription and the discharge summary, explained.',
  },
  {
    key: 'corporate',
    stage: 'deliver',
    name: 'Corporate',
    icon: 'Building2',
    line: "A workforce's health in one page, without anyone's name.",
  },
  {
    key: 'whatsapp',
    stage: 'growth',
    name: 'WhatsApp',
    icon: 'MessageCircle',
    line: 'Reports, reminders and replies where patients already are.',
  },
  {
    key: 'intelligence',
    stage: 'foundation',
    name: 'The intelligence layer',
    icon: 'Cpu',
    line: 'The knowledge, rules and security every product runs on.',
  },
];

export const productByKey = (key) => PRODUCTS.find((p) => p.key === key);
export const stageByKey = (key) => STAGES.find((s) => s.key === key);
